module.exports = "//public.zight.com/packs/media/images/pro-ribbon-40dfc67e3fc754ab17ff75ac7fb2125e.png";